// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileConversionQuery_graphql = require("../../__generated__/UnifiedProfileConversionQuery_graphql.bs.js");
let UnifiedProfileConversionConvertToTeamMutation_graphql = require("../../__generated__/UnifiedProfileConversionConvertToTeamMutation_graphql.bs.js");
let UnifiedProfileConversionConvertToIndividualMutation_graphql = require("../../__generated__/UnifiedProfileConversionConvertToIndividualMutation_graphql.bs.js");

let convertVariables = UnifiedProfileConversionConvertToTeamMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedProfileConversionConvertToTeamMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedProfileConversionConvertToTeamMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedProfileConversionConvertToTeamMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedProfileConversionConvertToTeamMutation_graphql.node, convertResponse, convertWrapRawResponse);

let ConvertToTeamMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = UnifiedProfileConversionConvertToIndividualMutation_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedProfileConversionConvertToIndividualMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedProfileConversionConvertToIndividualMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, UnifiedProfileConversionConvertToIndividualMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, UnifiedProfileConversionConvertToIndividualMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let ConvertToIndividualMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

function useConvertToTeam() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.convertUnifiedProfileToTeam;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function useConvertToIndividual() {
  let match = use$1();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit(input, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.convertUnifiedProfileToIndividual;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let convertVariables$2 = UnifiedProfileConversionQuery_graphql.Internal.convertVariables;

let convertResponse$2 = UnifiedProfileConversionQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = UnifiedProfileConversionQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$2, UnifiedProfileConversionQuery_graphql.node, convertResponse$2);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$2, UnifiedProfileConversionQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedProfileConversionQuery_graphql.node, convertResponse$2, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedProfileConversionQuery_graphql.node, convertResponse$2, convertVariables$2);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedProfileConversionQuery_graphql.node, convertResponse$2, convertVariables$2);

let retain = RescriptRelay_Query.retain(UnifiedProfileConversionQuery_graphql.node, convertVariables$2);

let Query_accountMemberRole_decode = UnifiedProfileConversionQuery_graphql.Utils.accountMemberRole_decode;

let Query_accountMemberRole_fromString = UnifiedProfileConversionQuery_graphql.Utils.accountMemberRole_fromString;

let Query = {
  accountMemberRole_decode: Query_accountMemberRole_decode,
  accountMemberRole_fromString: Query_accountMemberRole_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedProfileConversion(props) {
  let data = use$2(undefined, undefined, undefined, undefined);
  let match = useConvertToTeam();
  let saveToTeam = match[0];
  let match$1 = useConvertToIndividual();
  let saveToIndividual = match$1[0];
  let saving = match[1] || match$1[1];
  let match$2 = React.useState(() => false);
  let setFailed = match$2[1];
  let failed = match$2[0];
  let match$3 = React.useState(() => false);
  let setEditing = match$3[1];
  let match$4 = data.currentAccountV5.profile;
  let match$5;
  if (match$4 !== undefined && match$4.__typename === "IndividualAccountProfile") {
    let agent = match$4.agent;
    match$5 = agent !== undefined ? [
        Stdlib_Option.getOr(agent.brokerage, ""),
        Stdlib_Option.getOr(Stdlib_Option.map(agent.website, Scalars.URL.toString), "")
      ] : [
        "",
        ""
      ];
  } else {
    match$5 = [
      "",
      ""
    ];
  }
  let initialWebsite = match$5[1];
  let initialBrokerage = match$5[0];
  let match$6 = React.useState(() => initialBrokerage);
  let setBrokerage = match$6[1];
  let brokerage = match$6[0];
  let match$7 = React.useState(() => initialWebsite);
  let setWebsite = match$7[1];
  let website = match$7[0];
  let match$8 = React.useState(() => "");
  let setTeamName = match$8[1];
  let teamName = match$8[0];
  let individual = props.profileType === "Individual";
  let submit = () => {
    let onSuccess = param => {
      window.location.reload();
    };
    let onFailure = param => {
      setFailed(param => true);
      setEditing(param => false);
    };
    if (individual) {
      return saveToTeam({
        brokerage: brokerage,
        teamName: teamName,
        website: website
      }, onSuccess, onFailure);
    } else {
      return saveToIndividual(undefined, onSuccess, onFailure);
    }
  };
  if (data.currentAccountV5.viewerProfileRole !== "OWNER") {
    return null;
  } else {
    return JsxRuntime.jsxs("section", {
      children: [
        JsxRuntime.jsx("h3", {
          children: individual ? "Switch to a team profile" : "Switch to a personal profile",
          className: "text-xl font-medium"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => setEditing(param => true),
              children: "Switch profile type"
            }),
            failed ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                onClick: param => {
                  window.location.reload();
                },
                children: "Reload profile"
              }) : null
          ],
          className: "flex flex-wrap items-center gap-3"
        }),
        JsxRuntime.jsx(ConfirmDialog.make, {
          title: individual ? "Switch to a team profile?" : "Switch to a personal profile?",
          ariaLabel: "Confirm profile switch",
          body: JsxRuntime.jsx("div", {
            children: individual ? JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Form__Label.make, {
                    labelText: "Team name"
                  }),
                  JsxRuntime.jsx(Form__TextInput.make, {
                    onChange: event => setTeamName(param => event.target.value),
                    value: teamName
                  }),
                  JsxRuntime.jsx(Form__Label.make, {
                    labelText: "Brokerage"
                  }),
                  JsxRuntime.jsx(Form__TextInput.make, {
                    onChange: event => setBrokerage(param => event.target.value),
                    value: brokerage
                  }),
                  JsxRuntime.jsx(Form__Label.make, {
                    labelText: "Website"
                  }),
                  JsxRuntime.jsx(Form__TextInput.make, {
                    onChange: event => setWebsite(param => event.target.value),
                    value: website
                  }),
                  JsxRuntime.jsx("p", {
                    children: "The team will use the personal profile URL and social accounts. The owner will be public. Previously saved team About, photos, and display-only members are retained."
                  })
                ],
                className: "space-y-2"
              }) : JsxRuntime.jsx("p", {
                children: "Your personal profile and its previous URL will replace the public team profile. Team About, photos, and display-only members are retained. Switching back will use the personal URL and social accounts. You can review brokerage and website when switching back."
              }),
            className: "space-y-4"
          }),
          isOpen: match$3[0],
          onCancel: () => {
            if (!saving) {
              return setEditing(param => false);
            }
          },
          cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => setEditing(param => false),
            disabled: saving,
            children: "Cancel"
          }),
          confirmButton: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            onClick: param => submit(),
            disabled: saving || failed || individual && teamName.trim() === "",
            children: "Confirm switch"
          })
        }),
        match[2],
        match$1[2]
      ],
      className: "space-y-4 border-t border-zinc-200 pt-6"
    });
  }
}

let make = UnifiedProfileConversion;

exports.ConvertToTeamMutation = ConvertToTeamMutation;
exports.ConvertToIndividualMutation = ConvertToIndividualMutation;
exports.useConvertToTeam = useConvertToTeam;
exports.useConvertToIndividual = useConvertToIndividual;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
